export default "__VITE_ASSET__D497Ebsa__"